<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="texttemplate !== null">

    <div class="p-grid">
      <div class="p-col-6">
        <h2>{{ t('common.labels.files') }}</h2>
      </div>
      <div class="p-col-6 p-text-right">
        <button withRight="admin.texttemplate.edit" pButton (click)="onFileAdd()" type="button" label="{{ t('common.labels.add') }}" icon="pi pi-plus" class="p-button-sm p-mb-2 autofocus"></button>
      </div>
    </div>

    <div>
      <app-pill-nav [entries]="navEntries" (select)="onSelectLanguage($event)"></app-pill-nav>
    </div>

    <div class="p-grid p-fluid p-mt-4">
      <div class="p-col-12">

        <p-table [value]="fileLists[selectedLanguage?.id]" [paginator]="false" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
              <tr>
                <th>{{ t('common.labels.filename') }}</th>
                <th></th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-file>
              <tr class="tr-hover">
                <td>{{ file.public_name }}</td>
                <td class="p-text-right"><i class="pi pi-trash" (click)="onDeleteFile(file)"></i></td>
              </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td class="no-data" colspan="4">{{ t('common.texts.no_entries') }}</td>
            </tr>
          </ng-template>
        </p-table>

      </div>
    </div>

  </form>

  <p-dialog header="{{ t('common.labels.files') }}" [(visible)]="addFileVisible" [draggable]="false" [resizable]="false" modal="true" [style]="{width: '50vw'}">
    <app-loader [loading]="filesLoading"></app-loader>
    <p-table *ngIf="filesLoading !== true" [value]="allFiles" [paginator]="false" styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
          <tr>
            <th>{{ t('common.labels.filename') }}</th>
            <th></th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-file>
          <tr class="tr-hover" (click)="toggleFile(file)">
            <td>{{ file.public_name }}</td>
            <td class="p-text-right">
              <i *ngIf="file.added === true" class="pi pi-check"></i>
            </td>
          </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="no-data" colspan="4">{{ t('common.texts.no_entries') }}</td>
        </tr>
      </ng-template>
    </p-table>
    <p-footer>
      <button *ngIf="submittingFiles !== true" pButton (click)="onAddSubmit()" type="button" label="{{ t('common.labels.add') }}" class="p-button-primary"></button>
      <button *ngIf="submittingFiles === true" pButton type="button" label="{{ t('common.labels.add') }}" class="p-button-primary" disabled="true"></button>
    </p-footer>
  </p-dialog>
</ng-container>
